import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import moment from "moment";
import IconButton from "../../../common/components/IconButton";
import { BsCloudDownloadFill } from "react-icons/bs";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 20,
    marginBottom: 20,
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "uppercase",
  },
  section: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
  },
  card: {
    width: "48%",
    border: "1 solid #ccc",
    padding: 10,
    marginBottom: 10,
    borderRadius: 4,
  },
  label: {
    fontSize: 10,
    color: "#666",
    marginBottom: 2,
    textTransform: "uppercase",
  },
  value: {
    fontSize: 12,
    fontWeight: "bold",
  },
});

const DocumentPDF = ({ maintenance }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Ficha Técnica de Mantenimiento</Text>
        <View style={styles.section}>
          <View style={styles.card}>
            <Text style={styles.label}>Placa</Text>
            <Text style={styles.value}>{maintenance.plate}</Text>
          </View>
          <View style={styles.card}>
            <Text style={styles.label}>Tipo</Text>
            <Text style={styles.value}>{maintenance.type}</Text>
          </View>
          <View style={styles.card}>
            <Text style={styles.label}>Kilometraje</Text>
            <Text style={styles.value}>{maintenance.mileage}</Text>
          </View>
          <View style={styles.card}>
            <Text style={styles.label}>Fecha</Text>
            <Text style={styles.value}>
              {moment(maintenance.date).format("YYYY/MM/DD")}
            </Text>
          </View>
          {maintenance.nextPreventiveMaintenance && (
            <View style={styles.card}>
              <Text style={styles.label}>Próximo mantenimiento preventivo</Text>
              <Text style={styles.value}>
                {moment(maintenance.nextPreventiveMaintenance).format(
                  "YYYY/MM/DD"
                )}
              </Text>
            </View>
          )}
          <View style={styles.card}>
            <Text style={styles.label}>N° Factura</Text>
            <Text style={styles.value}>{maintenance.numberInvoice}</Text>
          </View>
          <View style={styles.card}>
            <Text style={styles.label}>Proveedor</Text>
            <Text style={styles.value}>{maintenance.provider}</Text>
          </View>
          <View style={styles.card}>
            <Text style={styles.label}>Valor de factura</Text>
            <Text style={styles.value}>${maintenance.valueInvoice}</Text>
          </View>
          <View style={[styles.card, { width: "100%" }]}>
            <Text style={styles.label}>Observaciones</Text>
            <Text style={styles.value}>{maintenance.observations || "—"}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

function TechnicalDataPDF({ maintenance, variant = "button" }) {
  return (
    <PDFDownloadLink
      document={<DocumentPDF maintenance={maintenance} />}
      fileName={maintenance.plate + "-" + maintenance.date + ".pdf"}
    >
      {({ loading }) => renderButton(variant, loading)}
    </PDFDownloadLink>
  );
}

function renderButton(variant, loading) {
  if (loading) {
    return <button className="btn btn-dark">Generando PDF...</button>;
  }

  if (variant === "icon") {
    return (
      <IconButton>
        <BsCloudDownloadFill size={25} />
      </IconButton>
    );
  }

  return <button className="btn btn-dark">Descargar PDF</button>;
}
export default TechnicalDataPDF;
